export const LOGO_STATIC_URI = require("../assets/images/vlinder-logo.png");
export const NO_IMAGE_AVAILABLE = require("../assets/images/no-picture-available-1.png");
